// extracted by mini-css-extract-plugin
module.exports = {"container":"AccessForbidden_container_II7Bx","title":"AccessForbidden_title_YqPMF","subtitle":"AccessForbidden_subtitle_2bEYg"};